// Kies per paginalaad een hoek, patroon en kleurenfamilie voor postgrid- en archiefarticles.
(() => {
	const articles = document.querySelectorAll('.wp-block-kadence-postgrid article.kt-blocks-post-grid-item, #archive-container article');
	const patterns = ['stack', 'row', 'square', 'corner', 'diagonal'];
	// Schud de patronen zodat korte lijsten ook verschillende varianten krijgen.
	for (let i = patterns.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[patterns[i], patterns[j]] = [patterns[j], patterns[i]];
	}
	articles.forEach((article, index) => {
		article.classList.add('article-blocks');
		article.dataset.blocksPosition = Math.random() < 0.5 ? 'left' : 'right';
		article.dataset.blocksPattern = patterns[index % patterns.length];
		article.dataset.blocksPalette = ['warm', 'yellow', 'blue', 'green'][Math.floor(Math.random() * 4)];
	});

	// Het onderste accent hoort bij het vaste sliderkader en behoudt een willekeurig palet.
	document.querySelectorAll('.iml-project-slider').forEach((slider) => {
		const article = slider.querySelector('article.article-blocks');
		if (!article) return;
		const colors = getComputedStyle(article);
		for (let i = 1; i <= 3; i++) {
			slider.style.setProperty(`--iml-slider-accent-${i}`, colors.getPropertyValue(`--iml-accent-${i}`));
		}
		const transparentCorner = Math.floor(Math.random() * 4) + 1;
		for (let i = 1; i <= 4; i++) {
			const accent = [2, 1, 1, 3][i - 1];
			slider.style.setProperty(`--iml-slider-corner-${i}`, i === transparentCorner ? 'transparent' : `var(--iml-slider-accent-${accent})`);
		}
	});

	// Titelaccenten houden hun vaste positie; kleur en vorm wisselen per paginalaad.
	const titlePatterns = ['stack', 'row', 'square', 'corner', 'reverse-corner', 'diagonal'];
	const titlePalettes = ['warm', 'yellow', 'blue', 'green', 'mixed'];
	document.querySelectorAll('.iml-post-title').forEach((title) => {
		title.dataset.blocksPattern = titlePatterns[Math.floor(Math.random() * titlePatterns.length)];
		title.dataset.blocksPalette = titlePalettes[Math.floor(Math.random() * titlePalettes.length)];
	});
})();
